<template>
  <div class="container">
    <Table :detail="detail" submitText="修改后提交" @send="send" />
  </div>
</template>

<script>
import Table from "@/views/bidding/evaluation/summary/components/table";
import { fetchDetail } from "@/api/bidding";
import { getJuryList, juryResubmit } from "@/api/bidding/evaluation";
import { mapMutations, mapActions } from "vuex";

export default {
  components: {
    Table,
  },
  data() {
    return {
      id: "", // 标段id
      taskId: "",
      instanceId: "",

      detail: {},
    };
  },
  mounted() {
    const { query } = this.$route;
    const { taskId, instanceId } = query || {};
    this.taskId = taskId || "";
    this.instanceId = instanceId || "";

    // 路由参数带 id，否则从业务主键解析
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
    } else {
      const { businessKey } = query || {};
      if (businessKey) {
        const parts = businessKey.split(":");
        this.id = parts.length > 1 ? parts[1] : "";
      }
    }

    if (this.taskId && this.instanceId) {
      this.setTaskId(this.taskId);
      this.setInstanceId(this.instanceId);
      // 加载审批详情，供提交时回传 extra
      this.fetchApprovalDetail();
    }

    if (this.id) {
      this.getDetail(this.id);
      this.getJuryList(this.id);
    }
  },
  methods: {
    ...mapMutations("approval", ["setTaskId", "setInstanceId"]),
    ...mapActions("approval", {
      finishTask: "finishTask",
      // 别名映射，避免与业务方法 getDetail 冲突
      fetchApprovalDetail: "getDetail",
    }),
    getDetail(id) {
      fetchDetail({ id }).then((res) => {
        this.detail = { ...res, juryLeaderRemarks: "", registerList: [] };
      });
    },
    getJuryList(id) {
      getJuryList(id).then((res) => {
        this.detail.juryLeaderRemarks = res.juryLeaderRemarks;
        this.detail.registerList = (res.registerList || []).map((item) => ({
          id: item.id, // 报名id
          userId: item.userId, // 报名单位id
          user: item.user, // 报名单位名称
          isPaymentResponse: item.isPaymentResponse,
          isQualification: item.isQualification,
          isSupplyScope: item.isSupplyScope,
          isTecBusiness: item.isTecBusiness,
          quoteFirst: item.quoteFirst,
          quoteSec: item.quoteSec,
          responseQuestion: item.responseQuestion,
          fileList: [
            {
              name: "资格审查材料",
              list: item?.filesQualificationList || [],
            },
            {
              name: "投标文件",
              list: item?.filesBusinessList || [],
            },
            {
              name: "投标保证金缴纳凭证",
              list: item?.filesBidBondCertList || [],
            },
            {
              name: "标书购买凭证",
              list: item?.filesBidBuyCertList || [],
            },
            {
              name: "其他文件",
              list: item?.filesOtherList || [],
            },
          ],
        }));
      });
    },
    send(value) {
      juryResubmit(value)
        .then(() => {
          this.$message.success("提交成功");
          this.$close(this.$route.path, "/approval/task");
        })
        .catch(() => {
          this.$message.error("提交失败");
        });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  background-color: #fff;
  padding: 48px 110px;
}
</style>
